<template>
  <div>
    <div class="col-12" style="display: flex; align-items: center">
      <button class="btn btn-info m-2" @click="goBack">Back</button>
      <button
        class="btn btn-info m-2"
        @click="doDisable"
        v-if="merchant.disabled === false"
      >
        Disable Category
      </button>
      <button class="btn btn-info m-2" @click="doEnable" v-else>
        Enable Category
      </button>
      <!-- <router-link
        class="btn btn-info m-2"
        :to="`/dashboard/merchant/${$route.params.id}/agents`"
        style="width: fit-content"
        :style="{ display: isInstitution ? 'none' : 'block' }"
      >
        View Agents
      </router-link> -->
    </div>

    <card class="card">
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-5">
              <fg-input
                type="text"
                label="Merchant Name"
                placeholder="Merchant Name"
                v-model="merchant.merchantName"
              >
              </fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="text"
                label="Company Name"
                placeholder="Company Name"
                v-model="merchant.companyName"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Email"
                placeholder="Email"
                v-model="merchant.email"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-8">
              <fg-input
                type="text"
                label="Business Address"
                placeholder="Address"
                v-model="merchant.address"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Wallet Id"
                placeholder="WalletId"
                :disabled="true"
                v-model="merchant.walletId"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Phone Number"
                placeholder="Phone Number"
                v-model="merchant.phoneNumber"
                maxlength="11"
                @input="
                  merchant.phoneNumber = merchant.phoneNumber.replace(/\D/g, '')
                "
              >
              </fg-input>
            </div>

            <div class="col-md-6">
              <label>State</label>
              <select
                class="form-control op-border"
                id="rate-type"
                v-model="merchant.state"
                required
                @change="fetchLgas()"
              >
                <option value="">State</option>
                <option v-for="st in utils.allStates" :key="st" :value="st">
                  {{ st }}
                </option>
              </select>
            </div>
          </div>

          <div class="row">
            <!-- <div class="col-md-4">
              <label>Country</label>
              <select
                class="form-control op-border"
                id="rate-type"
                v-model="merchant.country"
                required
                @change="getStates()"
              >
                <option value="">country</option>
                <option
                  v-for="(ct, index) in utils.countries"
                  :key="index"
                  :value="ct.code"
                >
                  {{ ct.name }}
                </option>
              </select>
            </div> -->

            <div class="col-md-6">
              <label>Local Government</label>
              <select
                class="form-control op-border"
                id="rate-type"
                v-model="merchant.localGovernment"
                required
              >
                <option value="">Select Local Government</option>
                <option v-for="lg in utils.lgas" :key="lg.id" :value="lg.name">
                  {{ lg.name }}
                </option>
              </select>
              <span v-if="utils.lgaLoading"> Fetching Lga's </span>
            </div>

            <div class="col-md-6">
              <label>Instant Settlement</label>
              <select
                class="form-control op-border"
                id="instant-settlement-enabled"
                v-model="merchant.instantSettlementEnabled"
              >
                <option :value="true">Enabled</option>
                <option :value="false">Disabled</option>
              </select>
            </div>
          </div>

          <div class="text-center">
            <p-button type="info" round @click.native.prevent="submit">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Update Merchant
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      merchant: {
        merchantName: "",
        companyName: "",
        email: "",
        address: "",
        phoneNumber: "",
        country: "",
        state: "",
        localGovernment: "",
        disabled: false,
        salesOfficerId: "",
      },
      allSalesOfficers: [],
      userType: localStorage.getItem("userType"),
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),
    isInstitution() {
      return this.userType === "INSTITUTIONS";
      // return this.userType === 'super-admin';
    },
    formattedSalesOfficers() {
      return this.allSalesOfficers.map((o) => ({
        ...o,
        fullName: `${o.firstName} ${o.lastName || ""}`.trim(),
      }));
    },
  },
  methods: {
    ...mapActions([
      "editMerchant",
      "getStates",
      "getLgas",
      "getCountries",
      "setLoading",
      "disableMerchant",
      "enableMerchant",
    ]),
    goBack() {
      window.history.back();
    },

    isValid(values) {
      let missingFields = [];

      if (!values.merchantName) {
        missingFields.push("Merchant Name");
      }
      if (!values.companyName) {
        missingFields.push("Company Name");
      }
      if (!values.address) {
        missingFields.push("Address");
      }
      if (!values.email) {
        missingFields.push("Email");
      }
      if (!values.phoneNumber) {
        missingFields.push("Phone Number");
      }
      if (!values.password) {
        missingFields.push("Password");
      }
      if (!values.password_confirmation) {
        missingFields.push("Password Confirmation");
      }

      if (!values.state) {
        missingFields.push("State");
      }
      if (!values.localGovernment) {
        missingFields.push("Local Government");
      }

      if (missingFields.length > 0) {
        this.$toast.error(
          `Please fill in all the following fields: ${missingFields.join(
            ", ",
          )}`,
        );
        return false;
      }

      return true;
    },

    submit() {
      this.$confirm("Update Changes?").then(() => {
        const data = { id: this.$route.params.id, ...this.merchant };
        this.editMerchant(data);
      });
    },
    fetchLgas() {
      this.merchant.lga = "";
      this.getLgas(this.merchant.state);
    },

    doDisable() {
      this.$confirm("You want to disable this merchant?").then(() => {
        this.disableMerchant({ id: this.$route.params.id }).then(() => {
          this.merchant.disabled = true;
          setTimeout(() => {
            this.getMerchant();
          }, 500);
        });
      });
    },

    doEnable() {
      this.$confirm("You want to enable this merchant?").then(() => {
        this.enableMerchant({ id: this.$route.params.id });

        this.merchant.disabled = false;
        setTimeout(() => {
          this.getMerchant();
        }, 500);
      });
    },

    async getMerchant() {
      this.setLoading(true);
      const res = await axios.get(
        `${process.env.VUE_APP_API_URL}/merchant/${this.$route.params.id}`,
      );
      const { merchant } = res.data;
      this.merchant = merchant;
      this.getLgas(this.merchant.state);
      this.setLoading(false);
    },

    async getSalesOfficers() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/user/get-all-users`,
        );
        this.allSalesOfficers = res.data.users;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Sales Officers",
          });
        }
      }
    },
  },
  async mounted() {
    // this.getCountries();
    this.getStates();
    await this.getMerchant();
    await this.getSalesOfficers();
  },
};
</script>
<style></style>
